/**
 * @name HttpRequest
 * @description
 * Http request
 */
export default class HttpRequest {

    constructor(C = {}) {
        this.C = {
            cacheTime: C.cacheTime || 20, // Cache in minutes
            Storage: mmkt.core.storage,
            md5: mmkt.core.md5
        }
    }

    /**
     * @description
     * HTTP Request
     * @param d.method {string} Request Method
     * @param d.url {string} URL
     * @param d.data {object} Post Data
     * @param d.token {string} Authentication token
     * @param d.responseType {string} Type of response (xhr || null)
     * @param d.cache {string} Active the localstorage cache of the request (true = default cachec time|| integer = minutes cache time)
     * @returns {object} Response Data
     */
    Request(d) {
        return new Promise(async resolve => {
            // Validate required parameters
            if (!d || typeof d !== 'object') {
                console.error('Request configuration object is required');
                return resolve({ error: 'Invalid request configuration' });
            }

            if (!d.method || typeof d.method !== 'string' || !['GET', 'POST', 'PUT', 'DELETE', 'PATCH'].includes(d.method.toUpperCase())) {
                console.error('Invalid or missing HTTP method:', d.method);
                return resolve({ error: 'Invalid HTTP method' });
            }

            if (!d.url || typeof d.url !== 'string' || !d.url.trim()) {
                console.error('Invalid or missing URL:', d.url);
                return resolve({ error: 'Invalid URL' });
            }

            // Validate data object for POST/PUT/DELETE/PATCH requests
            if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(d.method.toUpperCase()) && d.data && typeof d.data !== 'object') {
                console.error('Invalid data format:', d.data);
                return resolve({ error: 'Invalid data format' });
            }

            // Instances
            const
                { cacheTime, Storage, md5 } = this.C,
                { method, url, cache, token, responseType, data } = d,
                cacheName = cache ? md5(url) : null;

            // Return request from cache
            if(cache && Storage.getItem(cacheName)) return resolve(Storage.getItem(cacheName));

            // Starting XMLHttpRequest
            let xhr = await new XMLHttpRequest();
            xhr.open(method, url);

            // Get POST Content Type
            if ((method === 'POST' || method === 'PUT' || method === 'DELETE' || method === 'PATCH') && Object.keys(data).length) {
                // Check if data contains nested objects
                const hasNestedObjects = Object.values(data).some(value => typeof value === 'object' && value !== null && !Array.isArray(value));

                if (hasNestedObjects) {
                    // Use JSON for nested objects
                    xhr.setRequestHeader('Content-type', 'application/json');
                } else {
                    // Use form-urlencoded for simple key-value pairs
                    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                }
            }

            // Set Token Authentication in header
            if (token) xhr.setRequestHeader('authorization', d.token);

            // Call Request
            xhr.onload = function () {

                // Settings Item in Cache
                if(cache && xhr.status === 200) Storage.setItem(cacheName, xhr.responseText, typeof cache === 'boolean' ? cacheTime : cache);

                //If responseType is 'xhr' return xhr object, if xhr.status === 200 return 'xhr' object parsed else 'xhr' object
                resolve(responseType === 'xhr' ? xhr : xhr.status === 200 ? JSON.parse(xhr.responseText) : xhr);
            };

            // Parse Data
            if (data) {
                // Check if data contains nested objects
                const hasNestedObjects = Object.values(data).some(value => typeof value === 'object' && value !== null && !Array.isArray(value));

                if (hasNestedObjects) {
                    // Send as JSON for nested objects
                    xhr.send(JSON.stringify(data));
                } else {
                    // Send as form-urlencoded for simple key-value pairs
                    xhr.send(new URLSearchParams(Object.entries(data)).toString());
                }
            } else {
                xhr.send(null);
            }
        });
    }

    /**
     * @description
     * HTTP GET method
     * @param d {object} Request configuration object
     * */
    Get(d = {}){
        d.method = 'GET';
        return new Promise(resolve => {
            this.Request(d).then(res => resolve(res));
        });
    }
}